import React from "react";
import TitleAndPagination from "../components/Pagination";
import ProcessCard from "../components/Tender/ProcessCard";
import FinishedCard from "../components/Tender/FinishedCard";
import TopBar from "../components/TopBar";
import { useSelector } from "react-redux";
import { useState } from "react";
import { CONSTANTS } from "../shared/constants";
import { getVehiclesByAuction } from "../services/btc-api.service";
import { useEffect } from "react";
import { useMediaQuery } from "react-responsive";

export default function Tender() {
  const [selectedTab, setSelectedTab] = React.useState("inProcess");
  const user = useSelector((state) => state.user.user);
  const [limit, setLimit] = useState(20);
  const [offset, setOffSet] = useState(0);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [records, setRecords] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
    if (user && user._id) {
      getData(tab);
    }
  };

  useEffect(() => {
    if (user && user._id) {
      getData("inProcess");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, limit, offset]);

  const getData = async (selectedTabVal) => {
    setLoading(false);
    const data = await getVehiclesByAuction(
      limit,
      offset,
      user._id,
      CONSTANTS.AUCTION_TYPES.TENDER,
      selectedTabVal === "inProcess"
    );

    setRecords(data.records);
    setTotalRecords(data.totalRecords);
    setLoading(false);
  };

  const handleLimit = (e) => {
    setLimit(e);
  };
  const handlePageChange = (e) => {
    setOffSet(e);
  };

  return (
    <>
      <TopBar />
      <div className="auction-page container-fluid">
        <TitleAndPagination
          title={"Tender"}
          handlePageChange={handlePageChange}
          handleLimit={handleLimit}
          totalRecords={totalRecords}
          limit={limit}
        />

        <div className="auction-info">
          <button
            className={selectedTab === "inProcess" ? "selected" : ""}
            onClick={() => handleTabClick("inProcess")}
          >
            In Process
          </button>
          <button
            className={selectedTab === "finished" ? "selected" : ""}
            onClick={() => handleTabClick("finished")}
          >
            Finished
          </button>
        </div>
        {isMobile === false && (
          <div>
            {selectedTab === "inProcess" && loading === false && (
              <>
                {records &&
                  records.length > 0 &&
                  records.map((x) => <ProcessCard record={x} key={x._id} />)}
              </>
            )}

            {selectedTab === "finished" && loading === false && (
              <>
                {selectedTab === "finished" && (
                  <>
                    {records &&
                      records.length > 0 &&
                      records.map((x) => (
                        <FinishedCard record={x} key={x._id} />
                      ))}
                  </>
                )}
              </>
            )}
          </div>
        )}

        {isMobile && (
          <div>
            {selectedTab === "inProcess" && loading === false && (
              <>
                {records &&
                  records.length &&
                  records.map((x) => <ProcessCard card={x} key={x._id} />)}
              </>
            )}

            {selectedTab === "finished" && loading === false && (
              <>
                {records &&
                  records.length &&
                  records.map((x) => <FinishedCard card={x} key={x._id} />)}
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
}
